module.exports = __webpack_public_path__ + "static/media/ezsponsorlogo.790857b8.jpg";